// extracted by mini-css-extract-plugin
module.exports = {"root":"trigger_root__2tPCz"};